<template>
  <div id="surveySheet">
    <h2 style="text-align: center">工业互联网领域产业人才现状调研表 <br />工业互联网应用单位</h2>
    <vxe-form align="center" ref="formRef" :rules="formRules" :loading="loading" @submit="submitEvent" @reset="resetEvent" :data="formData" size="medium">
      <vxe-form-item span="8" title="公司名称" field="name" :item-render="{}">
        <template #default="{ data }">
          <vxe-input v-model="data.name" placeholder="请输入公司名称" clearable></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8" title="联系人" field="contacts" :item-render="{}">
        <template #default="{ data }">
          <vxe-input v-model="data.contacts" placeholder="请输入联系人" clearable></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8" title="联系方式" field="contactsPhone" :item-render="{}">
        <template #default="{ data }">
          <vxe-input v-model="data.contactsPhone" placeholder="请输入联系方式" clearable></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8" :title="`部\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0门`" field="dept" :item-render="{}">
        <template #default="{ data }">
          <vxe-input v-model="data.dept" placeholder="请输入部门" clearable></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8" :title="`职\u00A0\u00A0\u00A0务`" field="post" :item-render="{}">
        <template #default="{ data }">
          <vxe-input v-model="data.post" placeholder="请输入职务" clearable></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8" :title="`邮\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0箱`" field="email" :item-render="{}">
        <template #default="{ data }">
          <vxe-input v-model="data.email" placeholder="请输入邮箱" clearable></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24" align="left">
        填表说明：
        <br />
        （1）“技术研发人才”指与工业互联网领域相关的应用技术人才<br />
        （2）岗位范围主要为工业控制的研发、生产、实施、运维等相关岗位人才<br />
        （3）“岗位名称”包括但不限于仿真应用工程师、机械工程师、PLC工程师、自动化工程师、工业机器人工程师、工控系统工程师、仪器仪表工程师、运维工程师，如选择“其他”，请在“其他岗位”中填写具体岗位名称<br />
        （4）“岗位类别”主要包括但不限于研发类、生产类、实施类、运维类等<br />
      </vxe-form-item>
      <!-- 1.现有人才存量情况 -->
      <vxe-form-item span="24" align="left">
        <h3 style="margin-bottom: 10px">1.现有人才存量情况</h3>
        <surveItem1 ref="surve1" />
        <surveItem5 ref="surve5" />
      </vxe-form-item>
      <!-- 2.近年岗位招聘情况（2021-2023年） -->
      <vxe-form-item span="24" align="left">
        <h3 style="margin-bottom: 10px">2.近年岗位招聘情况（2021-2023年）</h3>
        <surveItem2 :roleList1="roleList1" ref="surve2" />
      </vxe-form-item>
      <!-- 3.岗位需求情况（2024-2025年） -->
      <vxe-form-item span="24" align="left">
        <h3 style="margin-bottom: 10px">3.岗位需求情况（2024-2025年）</h3>
        <surveItem3 :roleList1="roleList1" ref="surve3" />
      </vxe-form-item>
      <!-- 4.高层次人才需求情况 -->
      <vxe-form-item span="24" align="left">
        <h3 style="margin-bottom: 10px">4.高层次人才需求情况</h3>
        填表说明：
        <br />
        （1）“高层次人才”主要是顶尖人才、领军人才及在行业内具有较高影响力的高级技术专家，其中顶尖人才：包括诺奖获得者，国家最高科学技术奖获得者、中国科学院院士、中国工程院院士、中国社会科学院学部委员、国家“万人计划”杰出人才、美国、英国、加拿大、澳大利亚等发达国家科学院院士或者工程院院士，相当于上述层次的顶尖人才；国家级领军人才：指中组织部开展的国家人才工程入选者，国家“万人计划”中除杰出人才之外的人选、教育部“长江学者奖励计划”特聘教授;国家杰出青年科学基金获得者、国家自然科学奖、技术发明奖、科学技术进步奖特等奖、一等奖前2位完成人，相当于上述层次的领军人才；省级领军人才：指国家自然科学奖、技术发明奖、科技进步奖一等奖除前2位之外的完成人、二等奖前2位完成人，中国国际科学技术合作奖获得者，省、部、军队、国防自然科学奖、技术发明奖、科技进步奖一等奖前2位完成人，省科学技术奖最高获得者，泰山学者、泰山产业领军人才，中科院率先行动“百人计划”入选者，科技部创新人才推进计划人选，全国宣传文化系统“四个一批”人才，教育部“新世纪优秀人才支持计划”入选者，国家重点实验室、国家工程实验室、国家工程（技术）研究中心、国家认定企业技术中心主任，齐鲁文化名家，“外专双百计划”入选者，“齐鲁友谊奖”专家，担任过享受国务院特殊津贴专家，省有突出贡献的中青年专家，相当于上述层次的领军人才；高级技术专家，指行业内具有较高影响力的高级技术专家，具有行业领军企业高级技术职位工作经历的技术专家或高校高水平专家教授。
        <br />
        （2）“拟提供职位名称”主要指首席科学家、资深专家、总工程师、技术总监等高级技术与管理岗位。 <br />
        （3）“具备的研发平台”主要指国家（省）重点实验室、工程实验室、工程技术研究中心等科技创新平台。 <br />
        （4）“可提供的支持”主要指团队建设、项目支持、与高校院所联合进行技术研究等。 <br />
      </vxe-form-item>
      <vxe-form-item span="24" align="left">
        <surveItem4 ref="surve4" />
      </vxe-form-item>
      <vxe-form-item span="24">
        <template #default>
          <div style="margin-bottom: 50px">
            <vxe-button style="width: 120px" type="submit" status="primary" content="提交"></vxe-button>
            <vxe-button style="width: 120px" type="reset" content="重置"></vxe-button>
          </div>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
import moment from 'moment';
import surveItem1 from './surveItem1.vue';
import surveItem2 from './surveItem2.vue';
import surveItem3 from './surveItem3.vue';
import surveItem4 from './surveItem4.vue';
import surveItem5 from './surveItem5.vue';
export default {
  name: 'surveySheet',
  components: { surveItem1, surveItem2, surveItem3, surveItem4, surveItem5 },
  data() {
    return {
      loading: false,
      formData: {
        name: '',
        type: 2,
        contacts: '',
        contactsPhone: '',
      },
      formRules: {
        name: [{ required: true, message: '请输入公司名称' }],
        contacts: [{ required: true, message: '请输入联系人' }],
        contactsPhone: [{ required: true, message: '请输入联系方式' }],
        dept: [{ required: true, message: '请输入部门' }],
        email: [{ required: true, message: '请输入邮箱' }],
        post: [{ required: true, message: '请输入职务' }],
      },
      roleList1: [
        { label: '仿真应用工程师', value: '仿真应用工程师', disabled: false },
        { label: '机械工程师', value: '机械工程师', disabled: false },
        { label: 'PLC工程师', value: 'PLC工程师', disabled: false },
        { label: '自动化工程师', value: '自动化工程师', disabled: false },
        { label: '工业机器人工程师', value: '工业机器人工程师', disabled: false },
        { label: '工控系统工程师', value: '工控系统工程师', disabled: false },
        { label: '仪器仪表工程师', value: '仪器仪表工程师', disabled: false },
        { label: '运维工程师', value: '运维工程师', disabled: false },
        { label: '其他', value: '其他', disabled: false },
      ],
    };
  },

  created() {},
  mounted() {},
  methods: {
    moment,
    submitEvent() {
      this.loading = true;
      // setTimeout(() => {
      this.$nextTick(() => {
        const existingTalents = this.$refs.surve1.$refs.xTable.getTableData().fullData;
        const recentRecruitments = this.$refs.surve2.$refs.xTable.getTableData().fullData;
        const jobRequirements = this.$refs.surve3.$refs.xTable.getTableData().fullData;
        const highLevels = this.$refs.surve4.$refs.xTable.getTableData().fullData;
        const managementPersonnels = this.$refs.surve5.$refs.xTable.getTableData().fullData;
        this.$set(this.formData, 'existingTalents', existingTalents);
        this.$set(this.formData, 'recentRecruitments', recentRecruitments);
        this.$set(this.formData, 'jobRequirements', jobRequirements);
        this.$set(this.formData, 'highLevels', highLevels);
        this.$set(this.formData, 'managementPersonnels', managementPersonnels);
        console.log('🚀 ~ this.formData:', this.formData);
        this.setSompany(this.formData);
      });

      // }, 1000);
    },
    resetEvent() {
      this.$nextTick(() => {
        const existingTalents = this.$refs.surve1.$refs.xTable.getTableData().fullData;
        this.$refs.surve1.$refs.xTable.remove();
        this.$refs.surve2.$refs.xTable.remove();
        this.$refs.surve3.$refs.xTable.remove();
        this.$refs.surve4.$refs.xTable.remove();
        this.$refs.surve5.$refs.xTable.remove();
      });
    },

    setSompany(pamrs) {
      this.$axios.post('api/company/submit', pamrs).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data;
          this.loading = false;
          this.openAlert({ content: '提交成功', status: 'success' });
        } else {
          this.loading = false;
          this.openAlert({ content: res.data.msg, title: 'error 提示框', status: 'error' });
        }
      });
    },
    openAlert(options) {
      this.$VXETable.modal.alert(options);
    },
  },
};
</script>

<style lang="less" scoped>
#surveySheet {
  margin: 20px auto;
  max-width: 1280px;
  padding: 0 20px;
  // display: flex;
  // flex-direction: column;
  // text-align: center;
  // align-items: center;
}
/deep/ .vxe-form {
  margin-top: 50px;
  .vxe-form--wrapper {
    justify-content: center;
  }
  .vxe-cell--edit-icon {
    display: none;
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
